/* globals lp, rxSwitchboard */
;(function(){
  var juiEvents = rxSwitchboard.subjects.jui_events;

  var beforePageChangedEvs = juiEvents
    .filter(function(ev){
      return ev.type === 'beforeActivePageChanged';
    });
  var activeRootChanged = juiEvents
    .filter(function(ev){
      return ev.type === 'activeRootChanged';
    });
  var pageChangeTimingEvs = beforePageChangedEvs
    .timestamp()
    .flatMap(function(startEv){
      return activeRootChanged
        .take(1)
        .timestamp()
        .map(function(endEv) {
          return {
            duration: endEv.timestamp - startEv.timestamp,
            page: window.editor.page.usedAs()
          };
        });
  });

  lp.PerfSampling.registerSampleSource('pageChanged', pageChangeTimingEvs);

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/performance/perf_page_changed.js
// module id = 1066
// module chunks = 0